export type MobilePlatform = 'ios' | 'android'

/** The phone OS the page is open on, or null on desktop. iPadOS 13+ reports as a Mac but has touch points. */
export function getMobilePlatform(): MobilePlatform | null {
    if (typeof navigator === 'undefined') return null
    const userAgent = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(userAgent) || (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)) return 'ios'
    if (/android/.test(userAgent)) return 'android'
    return null
}
